export default "__VITE_ASSET__BpfuRivX__"